<template>
  <div class="container">
    <b-row>
      <b-container>
        <h2 class="text-center">
          {{labels.title}}
        </h2>
      </b-container>
    </b-row>
    <div class="row col-md-12">
      <div class="col-md-12 d-flex justify-content-end">
        <md-button style="background-color: #2e507a; width: 35px; height: 35px;" class="md-fab md-primary" @click="createRol()">
          <md-icon>add</md-icon>
        </md-button>
      </div>
    </div>
    <div class="row col-md-12 justify-content-center mt-2">
      <b-table
        :items="roles"
        :fields="fields"
        hover
        bordered
        responsive
        sticky-header="500px"
        small
        class="tblEstandar"
        head-variant="custom-blue"
        :per-page="perPage"
        :current-page="currentPage"
      >
        <template #cell(asociar)="data">
          <md-button
            style="background-color: #2e5072; width: 30px; height: 30px;"
            class="md-fab md-primary"
            @click="asociaMenu(data.item.id)"
          >
            <md-icon>list</md-icon>
          </md-button>
        </template>
        <template #cell(accionEdit)="data">
          <md-button
            style="background-color: #e5ac00; width: 30px; height: 30px;"
            class="md-fab md-primary"
            @click="editRol(data.item.id)"
          >
            <md-icon>edit</md-icon>
          </md-button>
        </template>
        <template #cell(accionInac)="data">
          <md-button
            style="background-color: #cd2838; width: 30px; height: 30px;"
            class="md-fab md-primary"
            @click="inactivarRol(data.item.id)"
          >
            <md-icon>delete</md-icon>
          </md-button>
        </template>
      </b-table>
      <div class="row col-12 mt-1">
        <div class="col-10 d-flex justify-content-center">
          <b-pagination
            v-model="currentPage"
            :per-page="perPage"
            :total-rows="roles.length"
            align="center"
            size="md"
            class="custom-pagination"
          ></b-pagination>
        </div>
        <div class="col-2 d-flex justify-content-end">
          <label class="mr-2 mb-0">Filas por página:</label>
          <b-form-select
          v-model="perPage"
          :options="[5, 10, 50, 100]"
          size="sm"
          style="width: 80px;"
          ></b-form-select>
        </div>
      </div>
    </div>
    <Create :showDialogCreate="showDialogCreate" @closeModal="cerrarModal" />
    <Edit :showDialogEdit="showDialogEdit" :Item="itemSelected" @closeModal="cerrarModal"/>
    <ModalAsociaMenu :modAsociaMenu="modAsociaMenu" :IdRol="rolId" @closeModal="cerrarModal"></ModalAsociaMenu>
  </div>
</template>

<script>
import Rol from "@/services/Roles";
import Edit from "./Edit.vue"
import Create from './Create.vue';
import ModalAsociaMenu from "./ModalAsociaMenu.vue";

export default {
    name: "Roles",
    components:{
      Edit,
      Create,
      ModalAsociaMenu
    },
    data: () => ({
      isLoading: false,
      error: false,
      isEmpty: false,
      searchRoles: null,
      roles:[],
      showDialogEdit: false,
      itemSelected: {},
      listRol:[],
      showDialogCreate: false,
      modAsociaMenu: false,
      rolId: "",
      perPage: 10,
      currentPage: 1,
      fields: [
        { key: 'nombre', label: 'Nombre'},
        { key: 'descripcion', label: 'Descripcion'},
        { key: 'asociar', label: 'Asociar menú', thClass: 'text-center', tdClass: 'text-center'},
        { key: 'accionEdit', label: 'Editar', thClass: 'text-center', tdClass: 'text-center'},
        { key: 'accionInac', label: 'Inactivar', thClass: 'text-center', tdClass: 'text-center'},
      ],
    }),
    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Roles",
                    instructive: ["Bienvenid@ a la plataforma para la visualización y administración de roles"],
                    create: "Crear",
                    name: "Nombre",
                    description: "Descripción",
                    associate: "Asociar menú",
                    edit: "Editar",
                    inactivate: "Inactivar",
                }
            }else {
                return {
                    title: "Roles",
                    instructive: ["Welcome to the platform for the visualization and manage of roles."],
                    create: "Create",
                    name: "Name",
                    description: "Description",
                    associate: "Associate menu",
                    edit: "Edit",
                    inactivate: "Inactivate",
                }
            }
        }
    },
    methods:{
      cerrarModal(val){
        this.showDialogEdit = val
        this.showDialogCreate = val
        this.modAsociaMenu = val
      },
      asociaMenu(idRol){
        // console.log(idRol)
        this.rolId = idRol
        this.modAsociaMenu = true
      },
        editRol(id){
            // console.log(id)
            // this.itemSelected = id;
            this.showDialogEdit = true;

            Rol.getAllRolesById(id)
            .then((rta) => {
              let datos = rta.data.rolById;
              // console.log(datos[0])
              this.itemSelected = datos[0];
            })
            .catch((error) => {
              console.log(error);
              this.error = true;
            })
            .finally(() => {
                this.isLoading = false;
            });
        },
        createRol(){
          this.showDialogCreate = true

        },
        inactivarRol(id){
            this.isLoading = true;
            Rol.inactivarRol(id)
            .then(() => {
                // console.log(rta)
                this.$toast.success("Rol inactivado correctamente")
                this.isLoading = false;
            })
            .catch(() => {
                this.$toast.error("El rol no se pudo inactivar")
            })
            .finally(() => {
                this.isLoading = false;
            });
        },
    },
    mounted(){
        this.isLoading = true;
        Rol.getAllRoles()
        .then((rta) => {
            // console.log(rta.data.roles)
            this.roles = rta.data.roles;
            this.getDataPagina(1);
        })
        .catch(() => {
        // console.log(error);
        this.error = true;
        })
        .finally(() => {
        this.isLoading = false;
        });
    }
}
</script>
<style src="../main.css">
</style>